import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CheckBoxIcon(props: IconProps) {
    return <Icon {...props} iconKey={"check_box"}/>
}
